interface usePrefetchLoomReturn {
	triggerPrefetch: () => void;
}

/**
 * Placeholder for usePrefetchLoom that returns an empty object
 * @returns Object containing triggerPrefetch function that does nothing
 */
export function usePrefetchLoomPlaceholder(): usePrefetchLoomReturn {
	return {
		triggerPrefetch: () => {},
	};
}

/**
 * TODO: load loom asynchronously
 * @returns Object containing triggerPrefetch function
 */
export function usePrefetchLoom(): usePrefetchLoomReturn {
	return {
		triggerPrefetch: () => {},
	};
}
